<template>
  <div class="b2c-rank-old-item container">
    <div class="header" :class="{ zlj: inZlj }">
      <img
        class="close"
        src="//pic1.zhuanstatic.com/zhuanzh/6cdfa717-73b8-4591-85b0-e9ab6dc0fd68.png"
        alt=""
        @click="togglePopup"
      />
    </div>
    <div class="nav">
      <!-- tab使用懒加载，否则swipe拿不到宽度 -->
      <z-tabs
        v-model="finenessLevelValueId"
        :swipe-threshold="6"
        :center="finenessDialogContents.length < 6"
        :ellipsis="false"
        @change="onChange"
      >
        <z-tab
          v-for="(tab, i) in finenessDialogContents"
          :id="String(tab.valueId)"
          :key="tab.valueId"
          :title="tab.finenessName"
        >
          <div class="content">
            <div class="content-box">
              <div v-if="tab.picUrls && tab.picUrls.length" class="swipe-content-wrap">
                <z-swipe ref="swipe" @change="onBannerChange">
                  <z-swipe-item v-for="(img, img_index) in tab.picUrls" :key="img_index">
                    <div class="swipe-img-wrap">
                      <img v-lazy="setPicSize(img, 686)" @click="checkImg(i, img_index)" />
                    </div>
                  </z-swipe-item>
                  <div v-show="tab.picUrls.length > 1" slot="indicator" class="custom-indicator">
                    {{ Number(tab.picUrlsCurrent) + 1 }}/{{ tab.picUrls.length }}
                  </div>
                </z-swipe>
              </div>
              <div v-show="!(tab.picUrls && tab.picUrls.length) && tab.videoUrl">
                <!-- tab使用懒加载后，如果一开始命中的tab需要展示video，不能通过index取值，只能通过名字来区分-->
                <z-biz-video
                  :ref="`videoRef${i}`"
                  class="content-video"
                  :video-url="tab.videoUrl"
                  :pic-url="setPicSize(tab.picUrl)"
                  px2rem
                  width="686"
                  height="440"
                  :auto="false"
                  :wifi-auto="false"
                  :mute-btn="false"
                  :showPlay="false"
                  :playPauseWithTimer="false"
                  @ended="endedVideoHandle(i)"
                  @started="startVideoPlay(i)"
                  @pause="pauseBtnShow = true"
                  @click="videoClick"
                />
                <div
                  v-show="pauseBtnShow"
                  ref="pauseBtnRef"
                  class="pause-btn"
                  @click="pauseBtnClick"
                >
                  <img
                    src="https://pic5.zhuanstatic.com/zhuanzh/ba50a305-3d92-469d-8ea9-3d5c85b0693d.png"
                  />
                </div>
              </div>
              <img
                v-show="tab.picUrl && !(tab.picUrls && tab.picUrls.length) && !tab.videoUrl"
                v-lazy="setPicSize(tab.picUrl)"
                class="content-img"
                alt=""
              />
            </div>
            <div class="content-notice">* 各机型使用痕迹不同，实际机况请以实拍图为准</div>
            <div class="content-advice">{{ tab.title }}</div>
            <div class="content-desc">
              {{ tab.finenessDesc }}
            </div>
          </div>
        </z-tab>
      </z-tabs>
    </div>
  </div>
</template>

<script>
  import native from '@zz-common/native-adapter'
  import { Tab, Tabs, BizVideo, Swipe, SwipeItem, ImagePreview } from '@zz-common/zz-ui'
  import { setPicSize } from '@zz-common/zz-utils'
  import buryingMixins from '../../mixins/zljBurypointMixins'
  import { lego } from '@zz-common/lego'

  export default {
    name: 'oldRankItem',
    data() {
      return {
        showPlayBtn: true,
        finenessLevelValueId: '',
        setPicSize,
        popupOpenTime: '',
        activeIndex: 0,
        pauseBtnShow: true,
        finenessDialogContents: [],
      }
    },
    mixins: [buryingMixins],
    components: {
      [BizVideo.name]: BizVideo,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
    },
    props: {
      inZlj: {
        type: Boolean,
        default: () => native.in('zlj'),
      },
      inZZ: {
        type: Boolean,
        default: () => native.in('zz'),
      },
      isMicro: {
        type: Boolean,
        default: false,
      },
      qualityRatingModule: {
        type: Object,
        default() {
          return {}
        },
      },
      eventName: {
        type: String,
        default() {
          return 'click_app'
        },
      },
      channelId: {
        type: Number,
        default() {
          return 0
        },
      },
      cateId: {
        type: Number,
        default() {
          return 0
        },
      },
      infoId: {
        type: String,
        default() {
          return ''
        },
      },
      pageId: {
        type: String,
        default: 'T2974',
      },
      sectionId: {
        type: String,
        default: '105',
      },
    },
    watch: {
      qualityRatingModule: {
        immediate: true,
        handler(obj) {
          this.finenessLevelValueId =
            obj.finenessDialogContents &&
            obj.finenessDialogContents.findIndex((v) => v.valueId == obj.finenessLevelValueId)
          this.activeIndex = this.finenessLevelValueId

          this.finenessDialogContents = (obj || {}).finenessDialogContents || []
          this.finenessDialogContents = this.finenessDialogContents.map((o) => {
            return { ...o, picUrlsCurrent: 0 }
          })
        },
      },
    },
    methods: {
      togglePopup() {
        if (this.isMicro) {
          this.pauseVideo()
          if (native.in('miniprogram')) {
            this.$emit('microClosePopup')
          } else {
            native.close(() => {
              this.$emit('microClosePopup')
            })
          }
        } else {
          this.$emit('togglePopup')
        }
      },
      endedVideoHandle(index) {
        this.pauseBtnShow = true
        this.channelId &&
          lego.send({
            pagetype: 'videoPlayEnd', // 埋点类型
            actiontype: this.pageId, // pageId
            backup: {
              sortName: '等级说明播放完毕',
              channelId: this.channelId,
              sortId: 3,
              firsttab: this.finenessDialogContents[this.activeIndex].finenessName, // tab名称
              infoId: this.infoId, // 商品id
              pl_id: this.cateId, // 品类id
              sectionId: this.sectionId,
            },
          })
        this.buryPointSend(this.eventName, {
          operation_module: '播完等级说明',
          tab_name: this.finenessDialogContents[index].finenessName,
        })
      },
      pauseBtnClick() {
        this.$nextTick(() => {
          this.pauseBtnShow && this.videoRef.$refs.video.click()
        })
      },
      pauseVideo(flag) {
        if (this.videoRef) {
          const video = this.videoRef.$refs.video
          if (video.currentTime > 0 && !video.paused && !video.ended) {
            if (!flag) {
              video.click()
            }
            this.pauseBtnShow = true
          }
        }
      },
      videoClick() {
        this.pauseVideo(true)
      },
      onChange(i) {
        this.pauseBtnShow = true
        this.pauseVideo()
        this.activeIndex = this.finenessDialogContents.findIndex(
          (v) => v.valueId == this.finenessLevelValueId
        )
        this.$nextTick(() => {
          this.channelId &&
            lego.send({
              pagetype: 'zpmclick', // 埋点类型
              actiontype: this.pageId, // pageId
              backup: {
                sortName: '查看等级说明',
                channelId: this.channelId,
                sortId: '4',
                firsttab: this.finenessDialogContents[this.activeIndex].finenessName, // tab名称
                infoId: this.infoId, // 商品id
                pl_id: this.cateId, // 品类id
                sectionId: this.sectionId,
              },
            })
          this.buryPointSend(this.eventName, {
            operation_module: '查看等级说明',
            tab_name: this.finenessDialogContents[this.activeIndex].finenessName,
          })
        })
      },
      startVideoPlay(index) {
        this.videoRef.$refs.video.muted = false
        this.pauseBtnShow = false
        if (this.videoRef.$refs.video.currentTime == 0) {
          this.channelId &&
            lego.send({
              pagetype: 'zpmclick', // 埋点类型
              actiontype: this.pageId, // pageId
              backup: {
                sortName: '播放等级说明',
                channelId: this.channelId,
                sortId: 2,
                firsttab: this.finenessDialogContents[this.activeIndex].finenessName, // tab名称
                infoId: this.infoId, // 商品id
                pl_id: this.cateId, // 品类id
                sectionId: this.sectionId,
              },
            })
          this.buryPointSend(this.eventName, {
            operation_module: '播放等级说明',
            tab_name: this.finenessDialogContents[this.activeIndex].finenessName,
          })
        }
      },
      watchVisibilitychange() {
        if (document.hidden) {
          this.pauseVideo()
        }
      },
      onBannerChange(index) {
        this.$set(this.finenessDialogContents[this.activeIndex], 'picUrlsCurrent', index)
      },
      checkImg(main_index, img_index) {
        const images = this.finenessDialogContents[main_index].picUrls
        const texts = new Array(images.length).fill(
          this.finenessDialogContents[main_index].finenessName
        )
        if (native.in('zlj')) {
          native.wrap('browsePicture')({
            list: images,
            index: img_index,
          })
        } else {
          ImagePreview({
            images,
            texts,
            startPosition: img_index,
            showClose: true,
            showLoading: true,
            adaptApp: true,
            adaptWeixin: true,
          })
        }
      },
    },
    computed: {
      // finenessDialogContents() {
      //   let result = (this.qualityRatingModule || {}).finenessDialogContents || []
      //   result = result.map((o) => {
      //     return { ...o, picUrlsCurrent: 0 }
      //   })
      //   return result
      // },
      videoRef() {
        const result = this.$refs[`videoRef${this.activeIndex}`]
        return result ? result[0] : null
      },
    },
    mounted() {
      document.addEventListener('visibilitychange', this.watchVisibilitychange, false)
      this.$nextTick(() => {
        if (this.videoRef) {
          if (this.videoRef.$refs.video) {
            this.videoRef.$refs.video.muted = false
          }
        }
      })
    },
    destroyed() {
      window.removeEventListener('visibilitychange', this.watchVisibilitychange)
    },
  }
</script>

<style lang="scss">
  @import '@zz-common/zz-ui/lib/style/mixins/ellipsis.scss';

  .z-image-preview__texts {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
  }

  .b2c-rank-old-item.container {
    .z-iphone-x {
      padding-bottom: 0 !important;
    }
    .z-tabs__nav {
      background: transparent !important;
    }
    .z-tab {
      color: #111111;
      font-weight: 300;
      padding: 0 25px;
    }
    .z-tabs__line {
      width: 30px;
      border-radius: 3px;
    }

    .header {
      position: relative;
      height: 148px;
      background-image: url('//pic4.zhuanstatic.com/zhuanzh/269cdaeb-5a84-43db-a5c5-41424dd9a33f.png');
      background-repeat: no-repeat;
      background-size: cover;
      backdrop-filter: blur(10px);
      display: flex;
      justify-content: center;
      align-items: center;
      &.zlj {
        background-image: url('//pic1.zhuanstatic.com/zhuanzh/b12729a6-3abe-4eab-9082-baaf8c07c18b.png');
      }
      .close {
        position: absolute;
        top: 42px;
        right: 32px;
        width: 24px;
        height: 24px;
      }
    }
    .nav {
      margin-top: -40px;
    }

    .content {
      padding: 0 32px;
      margin-top: 32px;

      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);

      .swipe-content-wrap {
        position: relative;
        height: 440px;

        .swipe-img-wrap {
          width: 686px;
          height: 440px;
          border-radius: 12px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .custom-indicator {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 686px;
          height: 66px;
          background: linear-gradient(360deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
      }

      .pause-btn {
        position: absolute;
        z-index: 9;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        border-radius: 50%;
        width: 16vw;
        height: 16vw;
        color: #fff;
        img {
          width: 100%;
          height: 100%;
        }
      }

      &-playBtn {
        position: absolute;
        right: 24px;
        top: 24px;
        width: 134px;
        height: 48px;
        background: #ffffff;
        border-radius: 24px;
        z-index: 11;
        display: flex;
        align-items: center;
        justify-content: center;
        .playBtn-icon {
          width: 10px;
          height: 12px;
          margin-right: 6px;
        }
        .playBtn-text {
          height: 24px;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #111111;
          line-height: 24px;
        }
      }
      &-video,
      &-img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }

      &-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 10;
        background: #ffffff;
      }

      &-box {
        position: relative;
        width: 686px;
        height: 440px;
        border-radius: 12px;
        overflow: hidden;
      }

      &-notice {
        height: 24px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        margin-top: 16px;
        text-align: left;
      }
      &-advice {
        margin-top: 48px;
        height: 36px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #111111;
        line-height: 36px;
        text-align: center;
        @include ellipsis();
      }
      &-desc {
        margin-top: 24px;
        height: 160px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
        @include multi-ellipsis(4);
      }

      .video-item {
        border-radius: 12px;
      }
    }
  }
</style>
